import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import ModalNotification from '@/shared/components/dialogs/ModalNotification';

type RemoveInventoryItemsDialogProps = {
  numberOfItemsToRemove: number;
  onClose: () => void;
  proceed: () => void;
};

const RemoveInventoryItemsDialog: FC<RemoveInventoryItemsDialogProps> = ({
  numberOfItemsToRemove,
  onClose,
  proceed,
}) => {
  const { t } = useTranslation(['inventory', 'common']);

  return (
    <ModalNotification
      fullWidth
      size='sm'
      open
      onClose={onClose}
      dialogProps={{
        title: t('inventory:removeInventoryItemsModal.title'),
        content: (
          <Trans
            i18nKey={'inventory:removeInventoryItemsModal.message'}
            ns='inventory'
            components={{ strong1: <strong /> }}
            count={numberOfItemsToRemove}
          />
        ),
        actions: [
          {
            label: t('common:cancel'),
            onClick: onClose,
          },
          {
            label: t('common:remove'),
            onClick: proceed,
            color: 'error',
            variant: 'contained',
          },
        ],
      }}
    />
  );
};

export default RemoveInventoryItemsDialog;
